// components/ConditionalOrders.js
import React from "react";
import { useSelector } from "react-redux";
import OrdersResturant from "views/OrdersResturant";
import WaiterOrdersResturant from "views/WaiterOrdersRestaurant";

const ConditionalOrders = () => {
  const { user } = useSelector((state) => state.auth);

  if (user?.type === "kitchen-waiter") {
    return <WaiterOrdersResturant />;
  }

  return <OrdersResturant />;
};

export default ConditionalOrders;
